export interface MockProgressProps {
  /** 0–100. Là SỐ vì nó vào cả `aria-valuenow` lẫn `width`. */
  readonly percent: number;
  readonly label: string;
}

/**
 * Thanh tiến độ 8px của `#pm`.
 *
 * Có `role="progressbar"` + `aria-value*`: đây là **số liệu thật người đọc cần biết**, không phải
 * hoạ tiết. Không khai thì screen reader bỏ qua một cái div và mất hẳn thông tin "68%".
 *
 * `width` đi qua `style` chứ không phải class: nó là giá trị CHẠY (đến từ dữ liệu), không phải
 * hằng thiết kế. Sinh class động từ dữ liệu là cách chắc chắn để Tailwind không thấy mà sinh CSS.
 */
export function MockProgress({ percent, label }: MockProgressProps) {
  return (
    <div
      role="progressbar"
      aria-valuenow={percent}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
      className="h-2 overflow-hidden rounded-pill bg-ink-100"
    >
      <div
        className="h-full bg-[image:var(--gradient-progress)]"
        style={{ width: `${String(percent)}%` }}
      />
    </div>
  );
}
